var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-pdf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M27.1937 14.2151H20.1706C18.2312 14.2151 16.6591 12.6429 16.6591 10.7035V3.68042M16.2424 21.2726C14.9732 19.826 14.2752 18.3006 15.2917 17.809C16.323 17.3102 16.5189 19.1553 16.2424 21.2726ZM16.2424 21.2726C16.8234 21.9351 17.5243 22.5808 18.2352 23.1035M16.2424 21.2726C16.135 22.0948 15.9564 22.958 15.728 23.7409M18.2352 23.1035C19.6966 24.1779 21.2006 24.7315 21.7942 23.8369C22.4652 22.8256 20.4747 22.7115 18.2352 23.1035ZM18.2352 23.1035C17.3917 23.2512 16.513 23.4705 15.728 23.7409M15.728 23.7409C13.8981 24.3709 12.5766 25.2774 13.3952 26.1958C14.2633 27.1696 15.1535 25.7089 15.728 23.7409ZM27.1937 13.9138V28.2613C27.1937 30.2007 25.6216 31.7729 23.6822 31.7729H9.63595C7.69657 31.7729 6.12439 30.2007 6.12439 28.2613V7.19198C6.12439 5.2526 7.69657 3.68042 9.63595 3.68042H16.9604C17.8916 3.68042 18.7848 4.05038 19.4434 4.70894L26.1652 11.4308C26.8238 12.0894 27.1937 12.9825 27.1937 13.9138Z",
    stroke: "#344054",
    strokeWidth: 2.80924,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.59a0ef4ae0604af8424b35276f8e4375.svg";
export { ForwardRef as ReactComponent };